/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { accountSchema } from './account-schema';
import { candidateSchema } from './candidate-schema';
import { userSchema } from './user-schema';

export const candidatesAccountSchema: z.AnyZodObject = z.object({
  account: z.lazy(() => accountSchema).nullish(),
  accountCandidateStatus: z.string().nullish(),
  accountId: z.string().uuid().nullish(),
  billingUnitsPerWeek: z.string().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  hasOtherEngagements: z.boolean().nullish(),
  id: z.string().uuid(),
  isHiddenExternal: z.boolean().nullish(),
  isHiddenExternalUpdatedAt: z.string().datetime().nullish(),
  isHiddenExternalUpdatedBy: z.string().uuid().nullish(),
  isHiddenExternalUpdatedByUser: z.lazy(() => userSchema).nullish(),
  notes: z.string().nullish(),
  notesUpdatedAt: z.string().datetime().nullish(),
  notesUpdatedBy: z.string().uuid().nullish(),
  notesUpdatedByUser: z.lazy(() => userSchema).nullish(),
  soonestAccountEngagementEndDate: z.string().datetime().nullish(),
  updatedAt: z.string().datetime().nullish(),
  weeklyTimeUnit: z.string().nullish(),
});

export type CandidatesAccount = z.infer<typeof candidatesAccountSchema>;
